import { render, staticRenderFns } from "./WhatIfsTableCountry.vue?vue&type=template&id=2816ce1e&"
import script from "./WhatIfsTableCountry.vue?vue&type=script&lang=js&"
export * from "./WhatIfsTableCountry.vue?vue&type=script&lang=js&"
import style0 from "./WhatIfsTableCountry.vue?vue&type=style&index=0&id=2816ce1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports